import React from 'react';
import './App.css';
import AppRoutes from './routes/Route';

function App() {
  return (
    <AppRoutes />
  );
}

export default App;
